import type { ReactNode } from 'react'

export type AlertProps = {
  variant?: 'info' | 'error' | 'success'
  title?: string
  children: ReactNode
}

export function Alert({ variant = 'info', title, children }: AlertProps) {
  return (
    <div className={`al-alert al-alert--${variant}`} role={variant === 'error' ? 'alert' : 'status'}>
      {title ? <strong className="al-alert__title">{title}</strong> : null}
      <div className="al-alert__body">{children}</div>
    </div>
  )
}
